import { Text } from '@rockalingua/ui';

export default Text;
